import { useState } from "react"
import { FileType } from "./index"
import axios from "axios"

export default function useFileUploader(url?: string) {
  const [selectedFile, setSelectedFile] = useState<FileType | null>()
  const [isLoading, setLoader] = useState<boolean>(false)

  /**
   * Handled the accepted files and shows the preview
   */
  const handleAcceptedFile = async (
    file: FileType,
    callback?: (files: FileType) => void
  ) => {
    try {
      const formData = new FormData()
      formData.append("file", file)
      setLoader(true)
      const { data } = await axios.post(url || "aws/s3/upload/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      setLoader(true)

      const uploadedFile = Object.assign(file, {
        url: data.url,
        key: data.key,
        data,
        formattedSize: formatBytes(file.size),
      })

      setSelectedFile(uploadedFile)
      setLoader(false)
      if (callback) callback(uploadedFile)
      return uploadedFile
    } catch (error) {
      setLoader(false)
    }
  }

  /**
   * Formats the size
   */
  const formatBytes = (bytes: number, decimals: number = 2) => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  /*
   * Removes the selected file
   */
  const removeFile = () => setSelectedFile(null)

  return {
    selectedFile,
    handleAcceptedFile,
    removeFile,
    isLoading,
  }
}
